// extracted by mini-css-extract-plugin
export var sectionHeader = "SectionHeader-module--sectionHeader--3LTBE";
export var title = "SectionHeader-module--title--10Ml0";
export var description = "SectionHeader-module--description--3P9vj";
export var show = "SectionHeader-module--show--3SkKG";
export var showFadeInDown = "SectionHeader-module--show-fade-in-down--ycmOa";
export var showFadeInUp = "SectionHeader-module--show-fade-in-up--2R81d";
export var hideFadeOut = "SectionHeader-module--hide-fade-out--1llb_";